import { MatDialogConfig } from "@angular/material/dialog";

/**
 * Default options for all Afidium MatDialogs.
 *
 * Use this class in app root module providers :
 * ```
 * {provide: MAT_DIALOG_DEFAULT_OPTIONS, useValue: new AfiMatDialogDefaultOptions()}
 * ```
 */
export class AfiMatDialogDefaultOptions implements MatDialogConfig {
    public maxHeight: string = "95vh";
    public hasBackdrop: boolean = true;
}
